import React, { useState, useEffect } from "react";
import { useParams } from "react-router";

import JikeiPortfolioDetail from "./JikeiPortfolioDetail";

import { useAppSelector, useAppDispatch } from "../../../../redux/hooks";
import {
  getPersonAdmin,
  getPersonData,
} from "../../../../redux/reducers/person";
import { getAuthToken } from "../../../../redux/reducers/auth";
import {
  getPersonOwners,
  updatePersonAdmin,
} from "../../../../redux/reducers/person";

import { RequestState } from "../../../../utils/RequestState";

const JikeiPortfolioDetailContainer: React.FC = () => {
  const { id } = useParams<{ id: string }>();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [selectStatus, setSelectStatus] = useState<string>();
  const [showStatusMenu, setShowStatusMenu] = useState<boolean>(false);
  const [requestState, setRequestState] = useState<RequestState>(
    RequestState.Waiting
  );

  const person = useAppSelector(getPersonData)[0];
  const owner = useAppSelector(getPersonOwners)[0];
  const auth_token = useAppSelector(getAuthToken);
  const dispatch = useAppDispatch();

  const handleStatusMenu = () => {
    setShowStatusMenu(!showStatusMenu);
  };

  const handleUpdate = () => {
    if (auth_token && id && selectStatus !== undefined) {
      setRequestState(RequestState.Doing);

      const update_args: { [key: string]: string } = {};
      update_args["sonic_status"] = selectStatus;

      dispatch(
        updatePersonAdmin({
          auth_token: auth_token,
          id: id,
          update: update_args,
          is_jikei_request: true,
        })
      ).finally(() => {
        setRequestState(RequestState.Success);
        setShowStatusMenu(false);
        setSelectStatus("");
      });
    }
  };

  useEffect(() => {
    if (auth_token) {
      setIsLoading(true);

      const promise = dispatch(
        getPersonAdmin({
          auth_token: auth_token,
          id: id,
          is_jikei_request: true,
        })
      );

      promise.finally(() => setIsLoading(false));

      return () => {
        promise.abort();
      };
    }
  }, []);

  // memo
  const [isMemoEdit, setMemoEdit] = useState<boolean>(false);
  const [memo, setMemo] = useState<string>();

  const handleMemoEdit = () => {
    setMemoEdit(true);
  };

  const handleMemoUpdate = () => {
    if (auth_token && id && memo !== undefined) {
      setRequestState(RequestState.Doing);

      const update_args: { [key: string]: string } = {};
      update_args["sonic_memo"] = memo;

      const promise = dispatch(
        updatePersonAdmin({
          auth_token,
          id: id,
          update: update_args,
          is_jikei_request: true,
        })
      );

      setMemoEdit(false);

      promise.finally(() => setRequestState(RequestState.Success));
    }
  };

  // works
  const [isModalShown, setIsModalShown] = useState<boolean>(false);
  const [workNumber, setWorkNumber] = useState<number>(0);

  return (
    <JikeiPortfolioDetail
      person={person}
      owner={owner}
      isLoading={isLoading}
      selectStatus={selectStatus}
      setSelectStatus={setSelectStatus}
      handleUpdate={handleUpdate}
      showStatusMenu={showStatusMenu}
      handleStatusMenu={handleStatusMenu}
      isMemoEdit={isMemoEdit}
      handleMemoEdit={handleMemoEdit}
      handleMemoUpdate={handleMemoUpdate}
      setMemo={setMemo}
      workNumber={workNumber}
      isModalShown={isModalShown}
      setWorkNumber={setWorkNumber}
      setIsModalShown={setIsModalShown}
      requestState={requestState}
    />
  );
};

export default JikeiPortfolioDetailContainer;
